export default {
    methods: {
        formattedNumber(value) {
            return numeral(value).format('0,0.00');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/formatted-number.js